import * as React from 'react';
import { useLink } from '@grandvisionhq/frk-routing';
import { useIsApplePaySupportedForCart } from '../../../hooks/use-is-apple-pay-supported-for-cart.js';
import { ApplePayButton } from './ApplePayButton.js';
import { ExpressPaymentMethod } from '../../../models/cart-payment-methods/cart-payment-methods.js';

const ApplePayExpressCheckoutButtonContainer = ({ cartId  })=>{
    const cartLink = useLink({
        route: 'cart.overview'
    });
    const expressCheckoutLink = useLink({
        route: 'express-checkout',
        params: {
            type: ExpressPaymentMethod.APPLE_PAY,
            returnPath: cartLink === null || cartLink === void 0 ? void 0 : cartLink.href,
            cartId
        }
    });
    const [getIsApplePaySupportedForCart, { isApplePaySupportedForCart , called , loading  }] = useIsApplePaySupportedForCart();
    React.useEffect(()=>{
        if (cartId) {
            getIsApplePaySupportedForCart(cartId);
        }
    }, [
        cartId,
        getIsApplePaySupportedForCart
    ]);
    if (!isApplePaySupportedForCart && called && !loading) {
        return null;
    }
    if (!expressCheckoutLink) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ApplePayButton, {
        type: "navigate-to-express-checkout",
        onClick: expressCheckoutLink.onClick
    });
};

export { ApplePayExpressCheckoutButtonContainer };
//# sourceMappingURL=ApplePayExpressCheckoutButtonContainer.js.map
